/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import Loader from "../../../../Utils/Loader";
import { Link, useNavigate } from "react-router-dom";
import { GO_TO_DASHBOARDS } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import { Pencil, Trash2, GanttChartSquare } from "lucide-react";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";

import { GET_ALL_GROUP_SERVICES } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import {
  GET_ALL_SERVICES_NAMES,
  DELETE_GROUP_SERVICE,
  GET_ALL_SERVICES_USER_NAMES,
} from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../Components/ExtraComponents/Modal";
import toast, { Toaster } from "react-hot-toast";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import Swal from "sweetalert2";

const ServicesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [first, setfirst] = useState("all");
  const [showModal, setshowModal] = useState(false);
  const [showModaluser, setshowModaluser] = useState(false);
  const [showDeletModal, setShowDeletModal] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [test, settest] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);

  const [getServicesName, setServicesName] = useState({
    loading: true,
    data: [],
  });
  const [getServicesuserName, setServicesuserName] = useState([]);
  const [AllGroupServices, setAllGroupServices] = useState({
    loading: true,
    data: [],
  });

  useEffect(() => {
    data();
  }, [refresh]);

  useEffect(() => {
    const filteredData = originalData.filter((item) => {
      return item.name.toLowerCase().includes(searchInput.toLowerCase());
    });
    setAllGroupServices({
      loading: false,
      data: searchInput ? filteredData : originalData,
    });
  }, [searchInput, originalData]);

  const columns = [
    {
      name: "Group Services Name",
      selector: (row) => row.name,
      cell: (row) => <div>{row.name || "-"}</div>,
      sortable: true,
    },
    {
      name: "Service Count",
      selector: (row) => row.resultCount,
      cell: (row) => <div>{row.resultCount || "-"}</div>,
      sortable: true,
    },
    {
      name: "Script Name",
      selector: (row) => row.categoryResult?.segment,
      cell: (row) => (
        <GanttChartSquare
          onClick={() => GetAllServicesName(row)}
          size={20}
          color="#198754"
          strokeWidth={2}
          className="mx-1"
        />
      ),
      sortable: true,
    },

    {
      name: "Service User",
      selector: (row) => row.categoryResult?.segment,
      cell: (row) => (
        <GanttChartSquare
          onClick={() => GetAllServicesUserName(row)}
          size={20}
          color="#198754"
          strokeWidth={2}
          className="mx-1"
        />
      ),
      sortable: true,
    },

    {
      name: "Actions",
      selector: () => null,
      cell: (row) => (
        <div>
          <Link to={`/admin/groupservices/edit/${row._id}`} title="Edit">
            <Pencil
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
            />
          </Link>
          <span title="Delete">
            <Trash2
              size={20}
              color="#d83131"
              strokeWidth={2}
              className="mx-1"
              onClick={() => DeleteGroup(row)}
            />
          </span>
        </div>
      ),
      sortable: false,
    },
    {
      name: "Created At",
      selector: (row) => row.result?.[0]?.createdAt,
      cell: (row) => (
        <div className="d-flex align-items-center gap-1">
          <span>
            {new Date(row.result?.[0]?.createdAt).toLocaleString() || "-"}
          </span>
        </div>
      ),
      sortable: true,
    },

  ];
  const columns1 = [
    {
      name: "Services Name",
      cell: (row) => <>
        {row?.data.img && <img src={row.data.img || "/default-image.png"} alt="User Avatar" style={{ width: "40px", height: "40px", borderRadius: "50%", marginRight: "10px" }} />}<div>{row.data.name || "-"}</div>
      </>,
      sortable: true,
    },
  ];

  const columns2 = [
    {
      name: "User Name",
      selector: (row) => row.user?.UserName || "-",
      sortable: true,
    },
    {
      name: "Go To Dashboard",
      selector: (row) => row.user?.TradingStatus,
      cell: (row) => (
        <button
          className={`btn ${row.user?.AppLoginStatus == "1" || row.user?.WebLoginStatus == "1"
              ? "btn-success"
              : "btn-danger"
            } btn-new-block`}
          onClick={() => goToDashboard(row)}
          disabled={
            row.user?.AppLoginStatus === "0" && row.user?.WebLoginStatus === "0"
          }
        >
          click
        </button>
      ),
      sortable: false,
    },
    {
      name: "License Type",
      selector: (row) => row.user?.license_type,
      cell: (row) =>
        row.user?.license_type === "2"
          ? "Live"
          : row.user?.license_type === "1"
            ? "Demo"
            : "2 Days Only",
      sortable: true,
    },
  ];

  const GetAllServicesName = async (row) => {
    setshowModal(true);
    await dispatch(
      GET_ALL_SERVICES_NAMES({
        data: row,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setServicesName({
            loading: false,
            data: response.data,
          });
        } else {
          setServicesName({
            loading: false,
            data: [],
          });
        }
      });
  };

  const GetAllServicesUserName = async (row) => {
    await dispatch(
      GET_ALL_SERVICES_USER_NAMES({
        _id: row._id,
      })
    )
      .unwrap()
      .then((response) => {
        settest(true);
        if (response.status) {
          setServicesuserName({
            loading: false,
            data: response.data,
          });
        } else {
          setServicesuserName({
            loading: false,
            data: [],
          });
        }
      });
  };

  // GO TO  CLIENT  DASHBOARD
  const goToDashboard = async (email) => {
    let req = {
      Email: email.user.Email,
    };
    await dispatch(GO_TO_DASHBOARDS(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          localStorage.setItem("gotodashboard", JSON.stringify(true));
          localStorage.setItem(
            "user_details_goTo",
            JSON.stringify(response.data)
          );
          localStorage.setItem(
            "user_role_goTo",
            JSON.stringify(response.data.Role)
          );
          localStorage.setItem("page", "groupservices");

          navigate("/client/dashboard");
        }
      });
  };

  const DeleteGroup = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this group service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row._id };
        try {
          const response = await dispatch(DELETE_GROUP_SERVICE(req)).unwrap();
          if (response.status) {
            toast.success(response.msg);
            setrefresh(!refresh);
            Swal.fire("Deleted!", "Group service has been deleted.", "success");
          } else {
            toast.error(response.msg || "Failed to delete.");
          }
        } catch (err) {
          toast.error("Something went wrong.");
        }
      }
    });
  };

  // GET ALL GROUP SERVICES NAME
  const data = async () => {
    await dispatch(GET_ALL_GROUP_SERVICES())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllGroupServices({
            loading: false,
            data: response.data,
          });
          setOriginalData(response.data);
        } else {
          setAllGroupServices({
            loading: false,
            data: response.data,
          });
        }
      });
  };



  return AllGroupServices.loading ? (
    <Loader />
  ) : (
    <>
      <Content
        Page_title="Group Service"
        button_title="Add Group"
        route="/admin/groupservices/add"
      >
        <div className="mx-0 row filter-row mt-3 mt-md-0 ">
          <div className="col-lg-4 col-md-6 col-9 ps-0">
            <div className="mb-3">
              <input
                type="text"
                placeholder="Search..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="form-control"
                id="exampleFormControlInput1"
              />
            </div>
          </div>

          <div className="col-lg-2 col-3">
            <button
              className="btn btn-sm btn-primary"
              title="Reset Filters"
              onClick={() => {
                setIsSpinning(true);
                setSearchInput("");
                setfirst("all");
                setrefresh((prev) => !prev);
                setTimeout(() => setIsSpinning(false), 1000);
              }}
            >
              <i className={`fa fa-refresh ${isSpinning ? "spin" : ""}`}></i>
            </button>
          </div>

        </div>

        <div className="position-relative">
          {AllGroupServices.loading || isSpinning ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "300px" }}
            >
              <Loader />
            </div>
          ) : (
            <Table columns={columns} data={AllGroupServices?.data || []} />
          )}
        </div>


        {showModal && (
          <>
            <Modal
              isOpen={showModal}
              backdrop="static"
              size="md"
              title="Services"
              hideBtn={true}
              handleClose={() => setshowModal(false)}
            >
              <Table
                columns={columns1}
                data={getServicesName && getServicesName.data}
              />
            </Modal>
          </>
        )}

        {test && (
          <>
            <Modal
              isOpen={test}
              backdrop="static"
              size="xl"
              title="Clients Using"
              hideBtn={true}
              handleClose={() => settest(false)}
            >
              <Table
                columns={columns2}
                data={getServicesuserName && getServicesuserName?.data}
              />
            </Modal>
          </>
        )}

        {showDeletModal == true && (
          <div
            className="modal custom-modal fade modal-delete"
            id="delete_modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="form-header">
                    <div className="delete-modal-icon">
                      <span>
                        <i className="fe fe-check-circle" />
                      </span>
                    </div>
                    <h3>Are You Sure?</h3>
                    <p>You want delete company</p>
                  </div>
                  <div className="modal-btn delete-action">
                    <div className="modal-footer justify-content-center p-0">
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="btn btn-primary paid-continue-btn me-2"
                      >
                        Yes, Delete
                      </button>
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn-back cancel-btn"
                      >
                        No, Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Content>
      {/* <ToastButton /> */}
    </>
  );
};

export default ServicesList;
